import React from 'react';
import { StaticObstacle } from '@tankworld/simulation';

interface ObstaclesProps {
  obstacles: StaticObstacle[];
}

export const TacticalObstacles: React.FC<ObstaclesProps> = ({ obstacles }) => {
  return (
    <group>
      {obstacles.map((obs) => {
        const { id, type, position, radius, height, width, length, rotation = 0 } = obs;

        if (type === 'barrier') {
          // Dragon's teeth anti-tank concrete barriers
          return (
            <group key={id} position={[position.x, position.y, position.z]} rotation={[0, rotation, 0]}>
              {[-2.5, 0, 2.5].map((offset, idx) => (
                <mesh key={idx} position={[offset, height * 0.45, 0]} castShadow receiveShadow>
                  <coneGeometry args={[1.2, height, 4]} />
                  <meshStandardMaterial color="#4f524d" roughness={0.9} />
                </mesh>
              ))}
            </group>
          );
        }

        if (type === 'bunker') {
          // Reinforced concrete military bunker
          const w = width || 10;
          const l = length || 10;
          return (
            <group key={id} position={[position.x, position.y + height * 0.5, position.z]} rotation={[0, rotation, 0]}>
              <mesh castShadow receiveShadow>
                <boxGeometry args={[w, height, l]} />
                <meshStandardMaterial color="#3e423d" roughness={0.85} />
              </mesh>
              {/* Slit gunport */}
              <mesh position={[0, height * 0.15, l * 0.51]}>
                <boxGeometry args={[w * 0.5, 0.4, 0.1]} />
                <meshBasicMaterial color="#111111" />
              </mesh>
            </group>
          );
        }

        if (type === 'building') {
          const w = width || 12;
          const l = length || 15;
          return (
            <group key={id} position={[position.x, position.y + height * 0.5, position.z]} rotation={[0, rotation, 0]}>
              <mesh castShadow receiveShadow>
                <boxGeometry args={[w, height, l]} />
                <meshStandardMaterial color="#514d47" roughness={0.9} />
              </mesh>
            </group>
          );
        }

        if (type === 'rock') {
          return (
            <mesh
              key={id}
              position={[position.x, position.y + height * 0.4, position.z]}
              castShadow
              receiveShadow
            >
              <dodecahedronGeometry args={[radius * 0.9, 1]} />
              <meshStandardMaterial color="#5a5b57" roughness={0.95} />
            </mesh>
          );
        }

        // Default tank wreck
        return (
          <group key={id} position={[position.x, position.y + 1.2, position.z]} rotation={[0, rotation, 0]}>
            <mesh castShadow>
              <boxGeometry args={[3.2, 1.8, 6.2]} />
              <meshStandardMaterial color="#2d2825" roughness={0.95} />
            </mesh>
          </group>
        );
      })}
    </group>
  );
};
